import { render, staticRenderFns } from "./pelepasandokumenlist.vue?vue&type=template&id=51f711f4&"
import script from "./pelepasandokumenlist.vue?vue&type=script&lang=js&"
export * from "./pelepasandokumenlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports